import { Component } from "solid-js";

interface AccessoriesIconProps {
  class?: string;
}

export const AccessoriesIcon: Component<AccessoriesIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M20.9661 29.3333H5.33411C3.79145 29.3333 2.57011 28.028 2.67278 26.4893L3.73411 10.5773C3.78078 9.87731 4.36211 9.33331 5.06478 9.33331H21.2354C21.9381 9.33331 22.5194 9.87731 22.5661 10.5773L22.8314 14.5553"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.1515 12V6.66669V6.66669V6.66669C17.1515 4.45735 15.3608 2.66669 13.1515 2.66669H13.1501C10.9408 2.66669 9.15015 4.45735 9.15015 6.66669V6.66669V6.66669V12"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="13.098"
        cy="21.7722"
        r="4.08944"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="24.1971"
        cy="21.7722"
        r="4.08944"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0938 21.3667H20.0844"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M28.9653 20.3667L27.9653 20.3667L27.9653 22.3667L28.9653 22.3667L28.9653 21.3667L28.9653 20.3667ZM29.8231 22.3667C30.3754 22.3667 30.8231 21.919 30.8231 21.3667C30.8231 20.8144 30.3754 20.3667 29.8231 20.3667L29.8231 21.3667L29.8231 22.3667ZM28.9653 21.3667L28.9653 22.3667L29.8231 22.3667L29.8231 21.3667L29.8231 20.3667L28.9653 20.3667L28.9653 21.3667Z"
        fill="#171717"
      />
      <path
        d="M8.22314 20.3667L9.22314 20.3667L9.22314 22.3667L8.22314 22.3667L8.22314 21.3667L8.22314 20.3667ZM7.36538 22.3667C6.81309 22.3667 6.36538 21.919 6.36538 21.3667C6.36538 20.8144 6.81309 20.3667 7.36538 20.3667L7.36538 21.3667L7.36538 22.3667ZM8.22314 21.3667L8.22314 22.3667L7.36538 22.3667L7.36538 21.3667L7.36538 20.3667L8.22314 20.3667L8.22314 21.3667Z"
        fill="#171717"
      />
    </svg>
  );
};
